import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceComplete, isResourceLoading } from './common';

const isTrainingsLoading = lruMemoize(isResourceLoading);
const getTrainings = lruMemoize(
    (data) => data.getIn(['trainings'], List()),
);

const getTrainingData = (state) => state.getIn(['app', 'training']);
const isTrainingLoaded = createSelector(getTrainingData, isResourceComplete);
const getTrainingTitle = createSelector(getTrainingData, (data) => data.getIn(['training', 'title']));

export {
    isTrainingLoaded,
    isTrainingsLoading,
    getTrainings,
    getTrainingTitle,
};
